module.exports = "### ToolbarSeparator Properties\n\nA vertical bar used to separate groups of components. \nIt is used to easily organize components within a `Toolbar`.\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/components/Toolbars/ToolbarSeparator.md
 ** module id = 895
 ** module chunks = 0
 **/